import React, { forwardRef, useCallback, useLayoutEffect, useRef } from 'react';

import scss from './TextareaAutosize.module.scss';

const TextAreaAutosize = forwardRef(function TextAreaAutosize(
  { maxHeight = 200, className, value, onPaste, ...props },
  ref,
) {
  const innerRef = useRef(null);

  const setRefs = (el) => {
    innerRef.current = el;

    if (typeof ref === 'function') {
      ref(el);
    } else if (ref) {
      ref.current = el;
    }
  };

  const resize = useCallback(() => {
    const el = innerRef.current;
    if (!el) return;

    el.style.height = 'auto';

    const nextHeight = Math.min(el.scrollHeight, maxHeight);

    el.style.height = `${nextHeight}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }, [maxHeight]);

  useLayoutEffect(() => {
    resize();
  }, [value, resize]);

  return (
    <textarea
      {...props}
      ref={setRefs}
      value={value}
      className={`${scss.textarea} ${className || ''}`}
      onPaste={onPaste}
      onInput={(e) => {
        resize();
        props.onInput?.(e);
      }}
    />
  );
});

export default TextAreaAutosize;
